// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__28gob","content":"styles_content__tbxAj","intro":"styles_intro__1YQf7"};